<script setup lang="ts">
import { CardAdmin } from '@shared/ui/cards'

import HelpersGrid from './HelpersGrid.vue'
import HelperActionRow from './HelperActionRow.vue'

defineOptions({
  name: 'HelpersSystemPage',
})
</script>

<template>
  <HelpersGrid>
    <CardAdmin
      title="Stripe"
      fullwidth
    >
      <HelperActionRow
        label="Pause Subscriptions"
        route-name="admin.helpers.stripe.pause-subscriptions"
      />
    </CardAdmin>
    <CardAdmin
      title="Subscription Credits"
      fullwidth
    >
      <HelperActionRow
        label="Apply upcoming subscription credits"
        route-name="admin.helpers.credits.apply-upcoming"
      />
    </CardAdmin>
    <CardAdmin
      title="Promocode"
      fullwidth
    >
      <HelperActionRow
        label="Expiration command"
        route-name="admin.helpers.promocodes.expire"
      />
    </CardAdmin>
    <CardAdmin
      title="Eve"
      fullwidth
    >
      <HelperActionRow
        label="Sync calls command"
        route-name="admin.helpers.eve.sync"
      />
    </CardAdmin>
    <CardAdmin
      title="Activation"
      fullwidth
    >
      <HelperActionRow
        label="Run Auto Activation"
        route-name="admin.helpers.activation.run-auto-activation"
      />
    </CardAdmin>
  </HelpersGrid>
</template>
